module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSuperHeavy.76e2cf1.woff";